<template>
  <div
    class="textComponents"
    ref="textComponentsRef"
    v-if="
      store.copywriting &&
      data.appInfo &&
      (Number(data.appInfo.creation_type) === 1 ||
        Number(data.appInfo.creation_type) === 2)
    "
  >
    <!-- 生成头像 -->
    <div
      class="imgQuit"
      v-if="data.appInfo && Number(data.appInfo.creation_type) !== 1"
    >
      <div class="title">选择模版</div>
      <div class="list">
        <div class="card" @click="data.imgPopup = true">更多</div>
        <div class="tabs hide-scrollbar">
          <div
            class="item"
            v-for="item in data.style.list"
            :style="
              data.judgeId('style', item) ? 'border:2px solid #8368FC' : ''
            "
            @click="data.quitTabs('style', item)"
            :key="item.id"
          >
            <img :src="item.show_icon" alt="" />
            <div class="tip">{{ item.opt_zh_name }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 生成头像 -->
    <!-- 对话框 -->
    <div
      class="BottomTextBox"
      :style="
        data.quitFlage ? 'flex-direction: column;align-items: flex-end;' : ''
      "
    >
      <van-field
        :class="data.quitFlage ? 'width-64' : ''"
        v-model="data.resultText"
        :clearable="true"
        rows="1"
        autosize
        type="textarea"
        @focus="data.focus"
        @blur="data.blur"
        :maxlength="data.appInfo.input_box_max_character"
        :placeholder="
          data.appInfo.input_box_placeholder +
          '(' +
          data.getPrice() +
          '花瓣/次)'
        "
        @update:model-value="data.modelValue"
        @clear="data.TextClaer"
      />
      <div class="textBtn" :class="data.quitFlage ? 'margin-18' : ''">
        <div v-if="data.quitFlage">
          {{
            data.resultText.length + "/" + data.appInfo.input_box_max_character
          }}
        </div>
        <div style="margin-left: 10px" v-if="data.quitFlage">
          {{ data.getPrice() + "花瓣/次" }}
        </div>
        <img
          class="icon-img"
          v-if="data.appInfo.creation_type === 1"
          src="@/assets/yuyin.png"
          alt=""
          @click.stop="emit('scrollBar', 0), (data.yuyinShow = !data.yuyinShow)"
        />
        <van-uploader
          v-else
          @click-upload="data.clickUpload"
          :after-read="afterRead"
        >
          <img class="icon-img" v-if="data.url" :src="data.url" alt="" />
          <img v-else class="icon-img" src="@/assets/icon.png" alt="" />
        </van-uploader>
        <div class="btn" v-if="data.quitFlage" @click.stop="data.create">
          开始创作
        </div>
      </div>
    </div>
    <!-- <div  class="textarea" :style="data.quitFlage?'flex-direction: column;align-items: flex-end;':''"  @click="data.clickTextarea" >
        <textarea ref="myTextarea" :class="data.quitFlage?'width-64':''" @focus='data.focus' @blur="data.blur" rows="1" :maxlength='data.appInfo.input_box_max_character' v-model="data.resultText" :placeholder="data.appInfo.input_box_placeholder+'('+Number(data.appInfo.petal_price)+'花瓣/次)'" @input="data.adjustHeight"></textarea>
        <div class="icon" :style="data.quitFlage?'margin-top:18px':''">
          <div>{{data.resultText.length+'/200'}}</div>
          <img class="icon-img" v-if="data.appInfo.creation_type === 1" src="@/assets/yuyin.png" alt="" @click.stop="data.yuyinShow = !data.yuyinShow">
          <van-uploader v-else @click-upload='data.clickUpload'  :after-read="afterRead" >
            <img class="icon-img" v-if="data.url" :src="data.url" alt="">
            <img v-else class="icon-img" src="@/assets/icon.png" alt="">
          </van-uploader>
          <div class="btn" v-if="data.quitFlage" @click.stop="data.create">开始创作</div>
        </div>
      </div> -->
  </div>
  <!-- 对话框 -->
  <div
    class="AppList"
    :class="store.isSafari ? 'isSafariClass' : ''"
    v-if="!store.copywriting"
  >
    <span>可能想用</span>
    <div class="list">
      <div
        class="item"
        @click="data.use(item)"
        v-for="item in data.AppList"
        :key="item.id"
      >
        <img :src="item.recommend_icon" alt="" />{{ item.name }}
      </div>
    </div>
  </div>
  <van-popup
    v-model:show="data.yuyinShow"
    @close="data.close"
    position="bottom"
    class="yuyin"
  >
    <div class="main">
      <div class="header">我在听，请说话</div>
      <img
        src="@/assets/homeClose.png"
        @click="data.registerClose"
        class="close"
      />
      <div class="time">{{ data.time + "''" }}</div>
      <Suspense>
        <template #default>
          <dictaticon
            @start="data.start"
            @end="data.end"
            @changeStr="data.getText"
          />
        </template>
      </Suspense>
      <div class="text">摁住说话</div>
    </div>
  </van-popup>
  <!-- 头像 -->
  <van-popup
    v-model:show="data.imgPopup"
    position="bottom"
    class="acitvePopup"
    round
    :style="{ height: '80%' }"
  >
    <div class="close" @click="data.imgPopup = false">
      <img src="@/assets/homeClose.png" alt="" />
    </div>
    <div class="header">更多模版选项</div>
    <div class="tip">
      作品公开<span>(生成后自动投稿至图库，获得推荐可返花瓣)</span>
    </div>
    <div class="acquiesce" @click="data.vipChange">
      默认全部不公开
      <div
        class="vip"
        :style="
          data.userInfo && data.userInfo.member_level === 1
            ? 'background: linear-gradient(119deg, #CCCCCC 0%, #999999 100%);color: #FFFFFF;'
            : ''
        "
      >
        VIP
      </div>
      <van-switch
        v-model="data.vipChecked"
        active-color="#8368FC"
        size="22"
        @change="data.change"
        :disabled="
          (data.userInfo && data.userInfo.member_level === 1) || !data.userInfo
        "
      />
    </div>
    <van-radio-group v-model="data.checked">
      <van-radio name="1">
        本次公开
        <template #icon="props">
          <img
            class="img-icon"
            :src="props.checked ? activeIcon : inactiveIcon"
          />
        </template>
      </van-radio>
      <van-radio name="0">
        本次不公开
        <template #icon="props">
          <img
            class="img-icon"
            :src="props.checked ? activeIcon : inactiveIcon"
          />
        </template>
      </van-radio>
    </van-radio-group>
    <van-tabs color="#8368FCFF" v-model:active="data.active">
      <van-tab
        v-for="item in data.lists"
        :name="item.opt_style"
        :key="item.id"
        :title="item.opt_zh_name"
      >
        <div class="scaling" v-if="data.active !== 'style'">
          <div
            class="card"
            v-for="card in item.list"
            @click="data.quitTabs(data.active, card)"
            :key="card.id"
            :style="
              data.judgeId(data.active, card)
                ? 'background:#8368FC;border-color:#ffffff;'
                : ''
            "
          >
            <div
              v-if="item.opt_style === 'scaling'"
              :class="data.judgeId(data.active, card) ? 'qiutBorderBorder' : ''"
              :style="data.getStyle(card.opt_zh_name, card.id)"
            ></div>
            <div
              class="text"
              :style="data.judgeId(data.active, card) ? 'color:#ffffff' : ''"
            >
              {{ card.opt_zh_name }}
            </div>
            <!-- data.quitScaling = card -->
          </div>
        </div>
        <div v-if="data.active === 'style'">
          <div class="masonry">
            <div id="column1" class="column" ref="column1">
              <div
                class="masonry-item"
                @click="data.quitTabs(data.active, item)"
                v-for="item in data.column1"
                :key="item.id"
              >
                <img
                  :src="item.show_icon"
                  :style="
                    data.judgeId(data.active, item)
                      ? 'border:1px solid #8368FC'
                      : ''
                  "
                  alt="Image"
                />
                <p>{{ item.opt_zh_name }}</p>
              </div>
            </div>
            <div id="column2" class="column" ref="column2">
              <div
                class="masonry-item"
                @click="data.quitTabs(data.active, item)"
                v-for="item in data.column2"
                :key="item.id"
              >
                <img
                  :src="item.show_icon"
                  :style="
                    data.judgeId(data.active, item)
                      ? 'border:1px solid #8368FC'
                      : ''
                  "
                  alt="Image"
                />
                <p>{{ item.opt_zh_name }}</p>
              </div>
            </div>
            <div id="column3" class="column" ref="column3">
              <div
                class="masonry-item"
                @click="data.quitTabs(data.active, item)"
                v-for="item in data.column3"
                :key="item.id"
              >
                <img
                  :src="item.show_icon"
                  :style="
                    data.judgeId(data.active, item)
                      ? 'border:1px solid #8368FC'
                      : ''
                  "
                  alt="Image"
                />
                <p>{{ item.opt_zh_name }}</p>
              </div>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </van-popup>
</template>

<script setup>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  watchEffect,
  computed,
  nextTick,
  watch,
} from "vue";
import { useCounterStore } from "@/store";
import { useRoute, useRouter } from "vue-router";
import dictaticon from "./dictation.vue";
import { getConfig, undateImg, editUserStatus } from "@/api/img";
import activeIcon from "@/assets/true.png";
import inactiveIcon from "@/assets/false.png";
import { lickApp, appDeteil } from "@/api/text";
import cross from "@/assets/cross.png";
import { showFailToast } from "vant";
import { userInfo } from "@/api/login";
import { getToken } from "@/ulits/auth";
const store = useCounterStore();
const route = useRoute();
const router = useRouter();
const data = reactive({});
const emit = defineEmits(["create", "scrollBar", "use", "img"]);
const textComponentsRef = ref(null);
data.height = "";
data.userInfo = JSON.parse(localStorage.getItem("userInfo"));
data.category_id = localStorage.getItem("category_id");
data.active = "";
data.vipChecked =
  data.userInfo && data.userInfo.member_level === 1
    ? false
    : data.userInfo && data.userInfo.is_info_public === 2
    ? true
    : false;
data.AppList = [];
data.imgPopup = false;
data.tabsDate = [];
data.quitStyle = {};
data.checked = data.userInfo && data.userInfo.member_level === 1 ? "1" : "0";
data.quitScaling = {};
data.scaling = {};
data.style = {};
data.lists = [];
data.column1 = [];
data.column2 = [];
data.column3 = [];
data.flage = true;
data.url = "";
data.time = 0;
data.start = (e) => {
  data.time = e;
};
data.end = (e) => {
  data.time = 0;
};

data.judgeId = computed(() => (type, e) => {
  let john = data.tabsDate.find(
    (item) => item.name === type && Number(item.id) === Number(e.id)
  );
  if (john) {
    return true;
  } else {
    return false;
  }
});

data.change = (e) => {
  if (e) {
    data.checked = "0";
  } else {
    data.checked = "1";
  }
  editUserStatus({
    user_id: data.userInfo.id,
    status: e ? 2 : 1,
  }).then((res) => {
    userInfo({ user_id: data.userInfo.id }).then((user) => {
      if (user.code === 200) {
        store.setUserInfo(user.data);
        localStorage.setItem("userInfo", JSON.stringify(user.data));
      }
    });
  });
};

// 上传图片
const afterRead = (file) => {
  undateImg(file.file).then((res) => {
    data.url = res.url;
    data.quitFlage = true;
    // 1二维码 2 头像
    if (data.appInfo.req_type !== 2) {
      data.resultText = "";
    }
  });
};
data.getConfigInfo = () => {
  getConfig({ app_id: data.appInfo.id }).then((res) => {
    if (res.code === 200) {
      store.setStyleList(res.data);
      data.lists = res.data;
      res.data.filter((i) => {
        if (i.opt_style === "scaling") {
          data.scaling = i;
        } else if (i.opt_style === "style") {
          data.style = i;
          data.column1 = data.style.list.filter(
            (item, index) => index % 3 === 0
          );
          data.column2 = data.style.list.filter(
            (item, index) => index % 3 === 1
          );
          data.column3 = data.style.list.filter(
            (item, index) => index % 3 === 2
          );
          data.quitTabs("style", data.style.list[0]);
        }
      });
    }
  });
};

data.getAppList = () => {
  lickApp({
    category_id: data.appInfo.category[0].id,
    app_id: data.appInfo.id,
  }).then((res) => {
    if (res.code === 200) {
      data.AppList = res.data;
    }
  });
};

data.clickUpload = () => {
  nextTick(() => {
    if (data.flage) {
      // myTextarea.value.focus()
    }
  });
};

// 获取识别过后的文字
data.resultText = "";
data.getText = (e) => {
  data.quitFlage = true;
  data.resultText = "";
  data.resultText += e;
  nextTick(() => {
    data.adjustHeight();
    data.height = textComponentsRef.value.offsetHeight;
    document.documentElement.style.setProperty(
      "--textHeader",
      `${(textComponentsRef.value.offsetHeight / 2 / 750) * 100}vw`
    );
  });
};

data.vipChange = () => {
  if (data.userInfo.member_level === 1) {
    // localStorage.setItem('type','1')
    router.push({
      name: "applianceTemplate",
      query: {
        title: "会员充值",
      },
    });
  }
};

//文本框自动延伸
data.quitFlage = false;
data.yuyinShow = false;
// 提交按钮
data.create = () => {
  data.flage = true;
  data.tabsDate.forEach((e) => {
    e.value = e.id;
    delete e.id;
  });
  if (data.appInfo.creation_type !== 1) {
    let parmas = {
      app_id: data.appInfo.id,
      is_open: data.checked,
      image_url: data.url,
      payload_json: JSON.stringify(data.tabsDate),
      prompt: data.resultText,
      span: [],
    };
    data.tabsDate.filter((i) => {
      data.lists.filter((j) => {
        if (i.name === j.opt_style) {
          parmas.span.push(j.opt_zh_name + "  " + i.opt_zh_name);
        }
      });
    });
    store.setImgParmas(parmas);
    emit("img");
    data.resultText = "";
  } else {
    if (data.resultText) {
      emit("create", data.resultText.trim());
      emit("scrollBar", 0);
      // store.copywritingFalse()
      data.resultText = "";
    } else {
      showFailToast({
        message: "请输入您要提问的问题",
        icon: cross,
      });
    }
  }
};

data.editText = (e) => {
  data.resultText = e;
  data.quitFlage = true;
  nextTick(() => {
    data.adjustHeight();
    data.height = textComponentsRef.value.offsetHeight;
    document.documentElement.style.setProperty(
      "--textHeader",
      `${(textComponentsRef.value.offsetHeight / 2 / 750) * 100}vw`
    );
  });
  store.copywritingTrue();
};
const myTextarea = ref(null);

data.adjustHeight = () => {
  const text = myTextarea.value;
  if (text) {
    text.style.height = "auto";
    text.style.height = text.scrollHeight + "px";
  }
};

// app_id: 20
// image_url: ""
// is_open: "0"
// payload_json: "[{"name":"scaling","id":4,"opt_zh_name":"4:3","show_icon":"","is_replace":-2},{"name":"color","id":232,"opt_zh_name":"自然绿","show_icon":"","is_replace":1},{"name":"texture","id":354,"opt_zh_name":"磨砂质感","show_icon":"","is_replace":1},{"name":"nail_shape","id":281,"opt_zh_name":"方形","show_icon":"","is_replace":1},{"name":"style","id":122,"opt_zh_name":"动漫角色","show_icon":"https://aibene-resource.huaji.com/config/midy/style/1695717450830973.png","is_replace":-1}]"
// prompt: "123"
// span: []

data.focus = () => {
  data.flage = true;
  nextTick(() => {
    document.documentElement.style.setProperty(
      "--textHeader",
      `${(textComponentsRef.value.offsetHeight / 2 / 750) * 100}vw`
    );
    data.quitFlage = true;
    data.height = textComponentsRef.value.offsetHeight;
    emit("scrollBar", 0);
    // emit('scrollBar',99999)
  });
};

data.getStyle = (e, id) => {
  let num = Number(e.split(":")[0]) + Number(e.split(":")[1]);
  let width =
    (((220 / num) * Number(e.split(":")[0])) / window.innerWidth) * 100;
  let height =
    (((220 / num) * Number(e.split(":")[1])) / window.innerWidth) * 100;
  let text = "";
  if (data.quitScaling.id === id) {
    text =
      "border:2px solid #ffffff;width:" + width + "px;height:" + height + "px;";
  } else {
    text =
      "border:2px solid #8368FCFF;width:" +
      width +
      "px;height:" +
      height +
      "px;";
  }

  return text;
};

data.blur = () => {
  setTimeout(() => {
    if (!data.resultText && !data.yuyinShow && !data.url) {
      document.documentElement.style.setProperty("--textHeader", `${0}px`);
      data.quitFlage = false;
    }
  });
  // setTimeout(()=>{data.flage = false})
};

data.close = () => {
  if (!data.resultText) {
    data.quitFlage = false;
  }
};

data.registerClose = () => {
  data.yuyinShow = false;
};

data.use = (e) => {
  appDeteil({ app_id: e.id }).then((res) => {
    localStorage.setItem("appInfo", JSON.stringify(res.data));
    data.appInfo = res.data;
    emit("use");
    data.quitFlage = false;
    store.copywritingTrue();
    data.getConfigInfo();
    lickApp({
      category_id: res.data.category[0].id,
      app_id: data.appInfo.id,
    }).then((link) => {
      if (link.code === 200) {
        data.AppList = link.data;
      }
    });
  });
};

data.imgEdit = (e) => {
  store.copywritingTrue();
  data.tabsDate = [];
  if (e.gen.split(" ").length >= 2) {
    data.url = e.gen.split(" ")[0];
    data.resultText = e.gen.split(" ")[1];
  } else {
    data.resultText = e.gen.split(" ")[0];
  }
  e.payload_json.map((e) => {
    e.id = e.value;
  });
  data.tabsDate = e.payload_json;
  data.quitFlage = true;
  nextTick(() => {
    data.adjustHeight();
    data.height = textComponentsRef.value.offsetHeight;
    document.documentElement.style.setProperty(
      "--textHeader",
      `${(textComponentsRef.value.offsetHeight / 2 / 750) * 100}vw`
    );
  });
};

data.TextClaer = () => {
  document.documentElement.style.setProperty("--textHeader", `${0}px`);
  nextTick(() => {
    data.height = textComponentsRef.value.offsetHeight;
  });
};

data.modelValue = () => {
  document.documentElement.style.setProperty(
    "--textHeader",
    `${(textComponentsRef.value.offsetHeight / 2 / 750) * 100}vw`
  );
  emit("scrollBar", 99999);
};
// data.clickTextarea = () =>{

//   nextTick(()=>{
//     myTextarea.value.focus()
//   })
//   // emit('scrollBar',99999)
// }

data.quitTabs = (type, e) => {
  let containsJohn = data.tabsDate.some((item) => item.name === type);
  if (containsJohn) {
    let john = data.tabsDate.find((item) => item.name === type);
    for (let i in e) {
      if (e.hasOwnProperty(i)) {
        john[i] = e[i];
      }
    }
  } else {
    data.tabsDate.push({
      name: type,
      ...e,
    });
  }
};

watch([() => data.yuyinShow], ([newText, newOtherProp]) => {});

data.getPrice = () => {
  if (data.userInfo && data.userInfo.member_level === 2) {
    return Number(data.appInfo.member_petal_price);
  } else {
    return Number(data.appInfo.petal_price);
  }
};

onBeforeMount(() => {});
onMounted(() => {
  // data.height = textComponentsRef.value.offsetHeight
  nextTick(() => {
    setTimeout(() => {
      data.appInfo = JSON.parse(localStorage.getItem("appInfo"));
      data.getAppList();
      if (data.appInfo.creation_type !== 1) {
        data.getConfigInfo();
      }
      data.adjustHeight();
    }, 1500);
  });
});
watchEffect(() => {
  data.appInfo = JSON.parse(localStorage.getItem("appInfo"));
});
defineExpose({
  ...toRefs(data),
});
</script>
<style lang="scss" scoped>
.textComponents {
  position: fixed;
  background: #111525;
  bottom: 0px;
  width: 100vw;
  z-index: 5;
  border-radius: 48px 48px 0px 0px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-bottom: 0;
  box-sizing: border-box;
  height: auto;
  // margin-bottom: 120px;
  .BottomTextBox {
    margin: 0 24px;
    display: flex;
    align-items: center;
    background: #323647;
    border-radius: 44px;
    margin-top: 32px;
    margin-bottom: 20px;
    ::v-deep().van-cell {
      background: #323647;
      border-radius: 44px;
      .van-field__body {
        padding: 0 32px;
        font-size: 28px;
        line-height: 40px;
        .van-field__control {
          color: #ffffff !important;
          max-height: 300px;
        }
      }
    }
    ::v-deep().van-cell:after {
      display: none;
    }
    .textBtn {
      color: #f7f5ff;
      display: flex;
      align-items: center;
    }
    .margin-18 {
      margin: 18px 12px;
    }
  }
  .textareaco {
    margin: 32px 24px 10px 24px;
    padding: 10px;
    background: #323647ff;
    font-size: 28px;
    display: flex;
    justify-content: space-evenly;
    border-radius: 44px;
    flex-direction: column;
    align-items: flex-end;
    // margin-bottom: 60px;
  }
  .textarea {
    z-index: 999;
    margin: 32px 24px 10px 24px;
    padding: 10px;
    background: #323647ff;
    font-size: 28px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    border-radius: 44px;
    // margin-bottom: 60px;
  }
  .icon {
    display: flex;
    align-items: center;
    padding-right: 8px;
    color: #f7f5ff;
  }
  .icon-img {
    width: 72px;
    height: 72px;
    padding-left: 24px;
  }
  .btn {
    width: 198px;
    height: 76px;
    text-align: center;
    color: #ffffff;
    line-height: 76px;
    background: #8368fcff;
    border-radius: 44px;
    margin-left: 48px;
  }
  textarea {
    line-height: 1;
    margin: 0 32px;
    color: #ffffff;
    margin-top: 10px;
    background: #323647ff;
    border: 0;
    flex: auto;
    width: calc(100% - 64px);
    resize: none;
  }
  .width-64 {
    width: 100%;
  }
}
.imgQuit {
  padding-left: 24px;
  font-size: 30px;
  color: #ffffff;
  .title {
    margin-top: 34px;
  }
  .list {
    display: flex;
    margin-top: 24px;
    .card {
      height: 100%;
      width: 100px;
      text-align: center;
      line-height: 136px;
      border-radius: 16px;
      font-size: 28px;
      background: #323647;
    }
    .tabs {
      margin-left: 20px;
      display: flex;
      overflow: hidden;
      width: calc(100% - 30px);
      flex: 1;
      overflow-x: auto;
      .item {
        flex-shrink: 0;
        position: relative;
        border-radius: 16px !important;
        margin-right: 24px;
        width: 136px;
        height: 136px;
        overflow: hidden;
      }
      .tip {
        position: absolute;
        bottom: 0;
        text-align: center;
        background: #11152540;
        border-radius: 0px 0px 16px 16px;
        width: 100%;
        color: #f7f5ff;
        font-size: 24px;
      }
      img {
        margin-right: 24px;
        padding: 0;
        width: 136px;
        // height: 136px;
        border-radius: 16px !important;
      }
    }
  }
}

// .hide-scrollbar::-webkit-scrollbar {
//     /* 网页工具条宽高 */
//     width: 0px;
//     height: 0px;
//     color:transparent;
// }
// .hide-scrollbar {
//     /* IE 10+ */
//     -ms-overflow-style: none;
//     /* Firefox */
//     scrollbar-width: none;
// }
.AppList {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding-top: 24px;
  font-size: 30px;
  height: 180px;
  color: #f7f5ff;
  background: #111525;
  padding-bottom: 30px;
  border-radius: 48px 48px 0px 0px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  span {
    position: relative;
    left: 24px;
  }
  .list {
    width: 95vw;
    white-space: nowrap;
    overflow-y: auto;
    margin: 0 24px;
    margin-top: 24px;
    display: flex;
    .item {
      display: flex;
      align-items: center;
      padding: 19px 16px;
      margin-right: 24px;
      background: #323647;
      border-radius: 24px;
      img {
        width: 48px;
        height: 48px;
      }
    }
  }
  .list::-webkit-scrollbar {
    display: none;
  }
}
.masonry {
  display: grid;
  margin-top: 10px;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 1em;
  padding: 0 10px;
}

.masonry-item {
  position: relative;
  break-inside: avoid;
  box-sizing: border-box;
  margin-bottom: 1em;
  border-radius: 0px 0px 16px 16px;
  img {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border-radius: 0px 0px 16px 16px;
  }
  p {
    position: absolute;
    bottom: 8px;
    width: 100%;
    text-align: center;
    background: #11152540;
    border-radius: 0px 0px 16px 16px;
    color: #f7f5ff;
    margin: 0;
    font-size: 26px;
  }
}
.qiutBorderBorder {
  border-color: #ffffff !important;
}
.isSafariClass {
  // padding-bottom: 120px;
}
</style>
<style>
.soundWaves::before {
  content: "";
  position: absolute;
  top: -10px;
  left: -10px;
  right: -10px;
  bottom: -10px;
  background: radial-gradient(circle, rgba(128, 184, 255, 0.5), transparent);
  border-radius: inherit;
  z-index: -1;
  opacity: 0;
  animation: wave 1s linear infinite;
}
:root {
  --van-radio-size: 30px !important;
  --van-radio-dot-size: 11px !important;
  --van-tab-font-size: 30px !important;
  --van-tabs-line-height: 67px !important;
  --van-tab-line-height: 67px !important;
}
</style>
